export default __webpack_public_path__ + "static/media/filterPlus.486e7de2.svg";